import { consola } from 'consola'

/** Совпадает с keys в features/notifications/model/usePushNotificationStorage */
const PUSH_KEYS = {
  PUSH_ENABLED: 'pushNotificationsEnabled',
  PUSH_ASKED: 'pushNotificationsAsked',
  PUSH_TOKEN: 'pushNotificationToken',
} as const

async function removeKey(key: string): Promise<void> {
  try {
    if (process.client) {
      const { Capacitor } = await import('@capacitor/core')
      if (Capacitor.isNativePlatform()) {
        const { SecureStoragePlugin } = await import('capacitor-secure-storage-plugin')
        await SecureStoragePlugin.remove({ key })
        return
      }
      localStorage.removeItem(key)
    }
  } catch (error) {
    consola.warn(`[clearPushNotificationSettings] Failed to remove ${key}:`, error)
    if (process.client) {
      localStorage.removeItem(key)
    }
  }
}

/**
 * Очистка локальных настроек push (logout / сброс приложения).
 * Не тянет слой features из entities/shared.
 */
export async function clearPushNotificationSettingsStorage(): Promise<void> {
  await Promise.all([
    removeKey(PUSH_KEYS.PUSH_ENABLED),
    removeKey(PUSH_KEYS.PUSH_ASKED),
    removeKey(PUSH_KEYS.PUSH_TOKEN),
  ])
}
